// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetDataItemPagedListRequestModel from '../../model/get-data-item-paged-list-request-model';
import GetDataItemPagedListRequestDTO from '../dto/get-data-item-paged-list-request-dto';
import dtoSchema from '../schemas/get-data-item-paged-list-request-schema';

export default abstract class GetDataItemPagedListRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetDataItemPagedListRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.categories = data.categories;
      this.tags = data.tags;
      this.contentType = data.contentType;
      this.contentStatus = data.contentStatus;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  */
  categories?: number[];
  /**
  */
  tags?: number[];
  /**
  * @type {int64}
  */
  contentType?: number;
  /**
  * @type {int64}
  */
  contentStatus?: number;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetDataItemPagedListRequestDTO>): GetDataItemPagedListRequestModel;
  static toModel(dto: DeepPartial<GetDataItemPagedListRequestDTO> | undefined | null): GetDataItemPagedListRequestModel | undefined;
  static toModel(dto: DeepPartial<GetDataItemPagedListRequestDTO> | undefined | null): GetDataItemPagedListRequestModel | undefined {
    return dto ? new GetDataItemPagedListRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetDataItemPagedListRequestModel> | GetDataItemPagedListRequestModel): GetDataItemPagedListRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      categories: unwrapped.categories,
      tags: unwrapped.tags,
      contentType: unwrapped.contentType,
      contentStatus: unwrapped.contentStatus,
      searchCriteria: unwrapped.searchCriteria,
    } as GetDataItemPagedListRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetDataItemPagedListRequestModel, can not map to GetDataItemPagedListRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
